module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external "aws-sdk/global"
// module id = 9
// module chunks = 0